<template>
  <div class="dialog-container wt-dialog-container">
    <div v-loading="isUserEmployeesDetailLoading">
      <wt-detail-form-section ref="formSection" :detail-form-data.sync="detailFormData" :detail-form.sync="detailForm" />
      <wt-detail-form-buttons :detail-form-buttons.sync="detailFormButtons" @on-detail-button-action="onDetailButtonAction"></wt-detail-form-buttons>
    </div>
  </div>
</template>

<script>
import request from '@/utils/request'
import { mapState } from 'vuex'
export default {
  name: 'UserEmployees-add',
  props: ['component-type'],
  isAutoComponent: true,
  data() {
    return {
      formCode: 'MODULES_USEREMPLOYEES',
      isSubmitLoading: false,
      formUpdateUrl: '/modules/userEmployees/userEmployeesUpdate',
      formAddUrl: '/modules/userEmployees/userEmployeesAdd',
      detailFormButtons: {
        title: '',
        elements: [
          { name: '提交', key: 'ADD', action: 'ADD', className: 'primary', hidden: this.componentType !== 'add' },
          { name: '提交', key: 'EDIT', action: 'EDIT', className: 'primary', hidden: this.componentType !== 'edit' },
          { name: '取消', key: 'CLOSE', action: 'CLOSE' }]
      },
      detailForm: {
        title: '新增工作人员账号',
        elements: [
          { name: '账号',
            key: 'userName',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 20, message: '账号长度不能超过20', trigger: 'blur' }
            ] },
          { name: '密码',
            key: 'password',
            type: 'password',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 20, message: '密码长度不能超过20', trigger: 'blur' }
            ] },
          { name: '社区', key: 'communityId', type: 'select', required: true, disabled: false, data: [] },
          { name: '是否可以投递垃圾', key: 'isHandleDelivery', type: 'select', required: true, disabled: false, data: [{ label: '是', value: 1 }, { label: '否', value: 0 }] },
          { name: '是否可以订单核销', key: 'isHandleOrder', type: 'select', required: true, disabled: false, data: [{ label: '是', value: 1 }, { label: '否', value: 0 }] },
          { name: '姓名',
            key: 'name',
            type: 'text',
            required: true,
            disabled: false,
            rules: [
              { min: 1, max: 20, message: '姓名长度不能超过20', trigger: 'blur' }
            ] },
          { name: '手机号',
            key: 'phone',
            type: 'text',
            disabled: false,
            required: true,
            rules: [
              { min: 11, max: 11, message: '手机号格式不正确', trigger: 'blur' },
              { pattern: this.$wtValidator.ValidatorPhonePattern, message: '手机号格式不正确', trigger: 'blur' }
            ] }]
      }
    }
  },
  created() {
    this.$store.dispatch('appendBreadcrumb', { meta: { title: '新增账号' }})
    this.requestcommunityList()
  },
  methods: {
    /*  ------------------------- 按钮  -------------------------  */
    onDetailButtonAction(item) {
      if (item.action === 'CLOSE') {
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'close')
      } else if (item.action === 'ADD') {
        this.onAdd()
      } else if (item.action === 'EDIT') {
        this.onSave()
      }
    },
    onAdd() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestAddUserEmployeesDetail()
      }).catch(() => {
      })
    },
    onSave() {
      const that = this
      this.$wtUtil.validateDetailFormsAndConfirm(this, '是否提交').then(() => {
        that.requestUpdateUserEmployeesDetail()
      }).catch(() => {
      })
    },
    /*  ------------------------- 网络请求  -------------------------  */
    requestAddUserEmployeesDetail() {
      const that = this
      this.$wtUtil.postFormData({
        url: this.formAddUrl,
        formData: this.detailFormData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
        this.$store.dispatch('removeBreadcrumb')
        this.$emit('on-dialog-action', 'refresh')
      })
    },
    requestUpdateUserEmployeesDetail() {
      const that = this
      this.$wtUtil.postFormData({
        url: this.formUpdateUrl,
        formData: this.detailFormData,
        isLoading: this.isSubmitLoading
      }).then(resp => {
        that.$message({ message: '保存成功', type: 'success' })
        that.$emit('on-dialog-action', 'close')
      })
    },
    requestcommunityList() {
      request({
        url: '/modules/community/communityNoPageList',
        method: 'post'
      }).then(res => {
        if (res.code == '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          this.detailForm.elements[2].data = res.data
        }
      })
    },
    onWtDialogClose() {
      this.$emit('on-dialog-action', 'close')
    }
  },
  computed: {
    ...mapState({
      isUserEmployeesDetailLoading: state => state.userEmployees.isUserEmployeesDetailLoading,
      detailFormData: state => state.userEmployees.userEmployeesDetailData
    })
  }
}
</script>

<style scoped>

</style>
